import {Component, OnInit, Inject, OnDestroy, ViewChild, AfterViewInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import {DigitalCertificateService} from 'src/app/core/services/digital-certificate.service';
import {NotificationService} from 'src/app/core/services/notification.service';
import {Message} from 'src/app/core/class/message';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {map, first} from 'rxjs/operators';
import {NgForm} from '@angular/forms';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-otp-verify',
  templateUrl: './otp-verify.component.html',
  styleUrls: ['./otp-verify.component.scss']
})
export class OtpVerifyComponent implements OnInit, OnDestroy, AfterViewInit {
  /**
   * Obj register
   */
  otp = {
    id: 0,
    enterpriseId: localStorage.getItem('enterpriseId'),
    typeCertificate: 3,
    phoneNumber: null,
    imagePath: null,
    digitalCertificateDetail: [],
    lstUserIdManagement: []
  };

  /**
   * Obj confirm
   */
  confirmOtp = {
    otp: null,
    transactionId: ''
  };

  /**
   * Check process success
   */
  success = false;

  // Whether the form change or not
  isFormChanging = false;

  show = true;

  // Refer to form in view
  @ViewChild('f', { static: false }) ngForm: NgForm;

  // Subscribe to form changing
  formChangesSubscription: Subscription;

  constructor(
    private digitalCertificateService: DigitalCertificateService,
    public dialogRef: MatDialogRef<OtpVerifyComponent>,
    public notificationService: NotificationService,
    private message: Message,
    private toastr: ToastrService,
    private router: Router,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.otp.phoneNumber = data.phone;
    this.otp.imagePath = data.imagePath;
    this.otp.lstUserIdManagement = data.lstUserIdManagement;
    this.otp.digitalCertificateDetail = data.digitalCertificateDetail;
    this.confirmOtp.transactionId = data.transaction;
  }

  /**
   * Init component
   */
  ngOnInit() {
    this.notificationService.subscribeErrorService();
  }

  /**
   * Init after view comp
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.focusInput();
    }, 300);
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
  }

  focusInput() {
    const otpInput = document.getElementById('otp');
    if (otpInput) {
      otpInput.focus();
    }
  }

  /**
   * Destroy component
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * Process verify OTP
   */
  onConfirmRegisterOTP() {
    this.digitalCertificateService.confirmOtp(this.confirmOtp).subscribe(rs => {
      this.registerOtp();
    });
  }

  /**
   * Process register OTP
   */
  registerOtp() {
    this.digitalCertificateService.add(this.otp).subscribe(rs => {
      this.show = false;
      this.toastr.success(this.message.getMessage('messages.register_otp_success'));
      this.success = true;
      this.dialogRef.close();
    });
  }

  /**
   * Send code OTP again
   */
  onSendCodeOTPAgain() {
    this.digitalCertificateService.generateTransaction(this.otp.phoneNumber).subscribe(rs => {
      this.confirmOtp.transactionId = rs.data;
      this.toastr.success(this.message.getMessage('messages.send_code_otp_again'));
    });
  }

  /**
   * Close dialog
   */
  onNoClick() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.show = false;
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    const tenantId = localStorage.getItem('tenantId');
    if ((this.isFormChanging && this.show && tenantId != null)
      || (this.show && tenantId != null)) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      return dialogRe.afterClosed().pipe(map(result => {
        if (result) {
          return true;
        } else {
          return false;
        }
      }), first());
    } else {
      return true;
    }
  }
}
